import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
type PageLayoutProps = {
  children: React.ReactNode;
};
export function PageLayout({
  children
}: PageLayoutProps) {
  return <main className="w-full" data-id="element-214">
      <Header data-id="element-215" />
      {children}
      <Footer data-id="element-216" />
    </main>;
}